module.exports = __webpack_public_path__ + "static/img/section_bg.674d57f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promotion/PR010103/section_bg.png
// module id = 9i5v
// module chunks = 10